import { render, staticRenderFns } from "./privacyAgreementDetails.vue?vue&type=template&id=132d2b3c&scoped=true"
var script = {}
import style0 from "./privacyAgreementDetails.vue?vue&type=style&index=0&id=132d2b3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132d2b3c",
  null
  
)

export default component.exports